module.exports = __webpack_public_path__ + "img/73-c45cc6.png";